<template>
  <div class="login-warpper">
    <div class="login-box">
      <h1>社会组织人才考试系统</h1>
      <div class="login-form">
        <h3>登 录</h3>

        <div class="form-item">
          <div class="form-icon">
            <img src="../assets/img/yonghu.png" alt="">
          </div>
          <input type="text" placeholder="请输入用户名" v-model="account">
        </div>
        <div class="form-item">
          <div class="form-icon">
            <img src="../assets/img/mima.png" alt="">
          </div>

          <input type="password" placeholder="请输入密码" v-model="pass">
          <router-link to="/forget" class="form-btn">忘记密码</router-link>
        </div>
        <div class="form-item">
          <drag-verify
              ref="dragVerify"
              :width="398"
              :height="48"
              :circle="false"
              :textSize="'14px'"
              completedBg="#189f92"
              progressBarBg="#189f92"

              :isPassing.sync="isPassing"
              text="请按住滑块拖动"
              successText="验证通过"
              handlerIcon="el-icon-d-arrow-right"
              successIcon="el-icon-circle-check"
              @passcallback="passcallback"
          >
          </drag-verify>
        </div>
        <div class="login-btn" @click="loginSubmit">立即登录</div>

      </div>
    </div>
    <div class="footer-warpper">
      Copyright 益魔方 <a target="_blank" href="http://beian.miit.gov.cn" class="margin-left-xs">京ICP备15038897号-3 </a>
      <img class="beian" src="http://www.beian.gov.cn/img/new/gongan.png">
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802038214"
         class="margin-right-xs">京公网安备11010802038214号</a>
      北京易魔方科技集团有限公司 版权所有
    </div>
  </div>
</template>

<script>
import {login} from '@/api/login'
import {ONLINEHOST, QAHOST} from "@/config";
import dragVerify from 'vue-drag-verify2'
export default {
  name: "login",
  data() {
    return {
      codeImg: (process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST) + '/admin/imgCode',
      account: '',
      pass: '',
      isPassing: false
    }
  },
  components:{
    dragVerify
  },
  created() {
  },
  methods: {
    passcallback() {
      this.isPassing = true
    },

    async loginSubmit() {
      if (!this.account) return this.$message.error('请输入用户名')
      if (!this.pass) return this.$message.error('请输入密码')
      if (!this.isPassing) return this.$message.error('请滑动验证')
      const loading = this.$loading({
        lock: true,
        text: '登录中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let _data = await login(this.account, this.pass,1)
      loading.close();
      if(_data.code  === 1003){
        this.$store.state.token1 = ''
        this.$store.state.token2 = _data.data.token

        if(Number(_data.data.org_type) === 6){
          window.localStorage.setItem('xietiao',_data.data.xtzx_id)
        }


        if(_data.data.noperfect === 1){
          if(_data.data.org_type === 2) return this.$router.push('/train/info?noperfect=1')
          if(_data.data.org_type === 3) return this.$router.push('/practiceBase/info?noperfect=1')
          if(_data.data.org_type === 4) return this.$router.push('/examination/info?noperfect=1')
          if(_data.data.org_type === 5) return this.$router.push('/fuse/info?noperfect=1')
        }else if(_data.data.shen === 1){
          this.$confirm("该机构将于"+_data.data.due_date+"日到期，以防影响您的正常使用，请及时前往机构信息页提交机构材料。", "温馨提示", {
            confirmButtonText: "立即前往提交",
            cancelButtonText: "我知道了",
            cancelButtonClass: "msg-btn",
            confirmButtonClass: "msg-btn",
            center: true
          }).then(() => {
            if(_data.data.org_type === 2) return this.$router.push('/train/info')
            if(_data.data.org_type === 3) return this.$router.push('/practiceBase/info')
            if(_data.data.org_type === 4) return this.$router.push('/examination/info')
            if(_data.data.org_type === 5) return this.$router.push('/fuse/info')

          }).catch(()=>{
            this.$router.push(_data.data.menu)
          });
        }else{
          this.$router.push(_data.data.menu)
        }

      }else if(_data.code  === 1004){
        this.$store.state.token1 = _data.data.token
        this.$router.push('/home')
      }else{
        console.log(this.$refs.dragVerify)
        this.isPassing = false
        this.$refs.dragVerify.reset();
      }


    }
  }
}
</script>

<style scoped lang="scss">
.footer-warpper {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
  background-color: rgba(0,0,0,0.3);
  color: #fff;
  flex-shrink: 0;
  position: fixed;
  left: 0;
  bottom: 0;
  a {
    font-size: 14px;
    color: #fff;
    margin: 0 5px;
  }
  .beian {
    width: 15px;
    height: 15px;
    margin: 0 5px;
  }
}
.login-warpper {
  display: block;
  width: 100%;
  min-height: 100vh;
  background: url(../assets/img/loginbg.jpg) no-repeat;
  background-size: 100% 100%;
  padding-bottom: 60px;

  .login-box {
    display: block;
    width: 457px;
    margin: 0 auto;
    padding-top: 170px;

    h1 {
      font-size: 40px;
      line-height: 60px;
      margin-bottom: 40px;
      letter-spacing: 4px;
      color: #333333;
      text-align: center;
    }

    .login-form {
      width: 457px;
      padding: 30px;
      background: url(../assets/img/Layer7.png) #ffffff no-repeat;
      background-position: -44px -120px;
      background-size: 550px;
      box-shadow: 0px 8px 18px 0px rgba(231, 231, 231, 0.32);
      border-radius: 8px;

      h3 {
        text-align: center;
        font-size: 28px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 60px;
        color: #333333;
        margin-bottom: 20px;
      }

      .form-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 398px;
        height: 48px;
        margin-bottom: 20px;
        background-color: #f5f5f5;
        border-radius: 4px;
        border: solid 1px #eeeeee;
        overflow: hidden;

        .form-icon {
          display: flex;
          align-items: center;
          justify-content: space-around;
          width: 46px;
          height: 46px;
        }

        input {
          flex: 1;
          display: block;
          font-size: 16px;
          height: 46px;
          background: transparent;
        }

        .form-btn {
          padding: 0 10px;
          color: #009688;
        }

        .form-yzm {
          display: block;
          width: 120px;
          height: 46px;
        }
      }
    }

    .login-btn {
      width: 398px;
      height: 56px;
      text-align: center;
      line-height: 54px;
      font-size: 18px;
      color: #fff;
      background-color: #189f92;
      border-radius: 4px;
      border: solid 1px #eeeeee;
      cursor: pointer;
    }
  }
}
</style>
